/**
 * Canonical RFI service / foundation scope names from the product catalog.
 * Used to label unknown values as "Custom" on document cards.
 */
export const RFI_CATALOG_SERVICE_NAMES = new Set([
  "Foundation - All",
  "Foundation - BusinessNew",
  "Foundation - QualityNew",
  "Foundation - TechnologyNew",
  "Data Management",
  "Data HostingNew",
  "Decentralized Trials",
  "Feasibility & Site SelectionNew",
  "General CRONew",
  "Investigator Site Budgets",
  "Medical Writing",
  "Project Management",
  "Site Monitoring - CRA",
  "Statistical Programming & Biostatistics",
  "Investigational & Medicinal Product Management",
  "Comparator SourcingNew",
  "CompoundingNew",
  "Controlled MaterialsNew",
  "Depot Services & Clinical Supply LogisticsNew",
  "DS/DP ManufacturingNew",
  "Packaging & LabelingNew",
  "QP Release Services (EU)New",
  "Radiolabeled MaterialsNew",
  "Temperature Controlled CouriersNew",
  "Bioanalytical",
  "Biomarker",
  "Central Lab",
  "MicrobiologyNew",
  "ECG",
  "EEGNew",
  "General Analytical (Release & Stability)New",
  "Imaging",
  "Sample Logistics & BiobankingNew",
  "Specialty (incl. DMPK)New",
  "HA Liaison ServicesNew",
  "IND/CTA SubmissionsNew",
  "IRBNew",
  "Medical Monitoring",
  "Pharmacovigilance",
  "Signal DetectionNew",
  "Real World Data/EvidenceNew",
  "Safety Boards & CommitteesNew",
  "Scientific AdvisoryNew",
  "Investigator Site",
  "Investigator Site File",
  "Patient Recruitment & Feasibility",
  "Recruitment & RetentionNew",
  "eHealth Records for Patient Recruitment & FeasibilityNew",
  "Patient Identification & Support ProgramsNew",
  "Patient Remote Visits",
  "Site Management - Site NetworksNew",
  "Telemedicine",
  "Translation ServicesNew",
  "CTMSNew",
  "Digital AdvertisingNew",
  "eCOA/ePRO",
  "Electronic Data CaptureNew",
  "eHealth Records to EDC Connector AppsNew",
  "Informed Consent",
  "Retention & Archival (Paper & Electronic)New",
  "RTSM",
  "Trial Master File",
  "Wearables (All Types)",
]);

/** Match audit/VQA styling when no catalog color is found */
export const DEFAULT_RFI_BADGE_STYLE = {
  bgColor: "#EEF2FF",
  textColor: "#4338CA",
  borderColor: "#4338CA",
};

function normalizeForCatalogLookup(name) {
  if (!name || typeof name !== "string") return "";
  return name.trim();
}

/**
 * True if the string matches the catalog (exact, case-insensitive, or API variant without glued "New").
 */
export function isKnownRfiCatalogServiceName(rawName) {
  const n = normalizeForCatalogLookup(rawName);
  if (!n) return false;
  if (RFI_CATALOG_SERVICE_NAMES.has(n)) return true;
  const lower = n.toLowerCase();
  for (const k of RFI_CATALOG_SERVICE_NAMES) {
    if (k.toLowerCase() === lower) return true;
  }
  // API may omit trailing "New" present in marketing names
  const withoutNew = n.replace(/New$/i, "").trim();
  if (withoutNew !== n) {
    if (RFI_CATALOG_SERVICE_NAMES.has(withoutNew)) return true;
    for (const k of RFI_CATALOG_SERVICE_NAMES) {
      if (k.toLowerCase() === withoutNew.toLowerCase()) return true;
    }
  }
  // Catalog entry "FooNew" vs API "Foo"
  const withNew = `${n}New`;
  if (RFI_CATALOG_SERVICE_NAMES.has(withNew)) return true;
  return false;
}

/**
 * Badge label for RFI scope: catalog name, or "Custom" when not in the official list.
 * Preserves legacy "Core Capabilities" label used elsewhere.
 */
export function getRfiCapabilityBadgeDisplayName(rawName) {
  const n = normalizeForCatalogLookup(rawName);
  if (!n) return "Custom";
  if (n === "Core Capabilities") return "Core Capabilities";
  if (isKnownRfiCatalogServiceName(n)) return n;
  return "Custom";
}
